import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default function EditorialEmptyState({
  icon,
  title,
  description,
  action,
  className = '',
  variant = 'card',
}) {
  const classes = ['ed-empty-state', `ed-empty-state--${variant}`, className].filter(Boolean).join(' ');
  return (
    <div className={classes}>
      {/* Decorative only — the title carries the meaning. */}
      {icon ? <span className="ed-empty-state__icon" aria-hidden="true">{icon}</span> : null}
      {title ? <div className="ed-empty-state__title">{title}</div> : null}
      {description ? <div className="ed-empty-state__desc">{description}</div> : null}
      {action ? <div className="ed-empty-state__action">{action}</div> : null}
    </div>
  );
}

EditorialEmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node,
  description: PropTypes.node,
  action: PropTypes.node,
  variant: PropTypes.oneOf(['card', 'inline']),
  className: PropTypes.string,
};
